import "../../styles/global.scss";
import { Container, Row, Col, Form, Button, ProgressBar } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import happyKids from "../../images/reading.png";
import styles from "../../styles/login.module.scss";
import utilStyles from "../../styles/utils.module.scss";
import axios from "axios";
import { serverUrl } from "../../helpers/utility";
import { AnimatePresence, motion } from "motion/react";
import { useState } from "react";
import { mutate } from "swr";
import InputWithLabel from "../../components/inputWithLabel";

function ProviderSignUp() {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setError,
    clearErrors,
  } = useForm();
  let navigate = useNavigate();
  const [step, setStep] = useState(0);
  const formValues = watch();

  // WARN: When editing use the ngrok domain as localhost will be blocked!
  async function onSubmit(data) {
    try {
      if (
        data.tradingName?.length >= 2 &&
        data.companyNumber?.length >= 7 &&
        data.username &&
        data.password
      ) {
        const provider = {
          companyNumber: data?.companyNumber,
          tradingName: data?.tradingName,
          website: data?.website,
        };

        const user = {
          firstName: data?.firstName,
          lastName: data?.lastName,
          email: data?.username,
          password: data?.password,
        };

        console.log(`Submitting provider form...`);

        axios
          .post(`${serverUrl}/user/register/email`, { user, provider })
          .then(async (response) => {
            console.log(JSON.stringify(response.data));

            // Persist to redux store, redirection then handled by componentDidUpdate (redux store update!)
            if (response && response.data && response.data.success) {
              const { user, token } = response.data;
              console.log(`--- User is: ${user?._id}`);

              localStorage.setItem("token", token);
              await mutate(`${serverUrl}/user`);
              await mutate(`${serverUrl}/location`);
            } else {
              console.info(`ERR: Could not register. ${JSON.stringify(response.data)}`);
            }
          })
          .catch((error) => {
            console.error(`Unable to login, server error. ${JSON.stringify(error)}`);

            if (error.response && error.response.data && error.response.data.message) {
              alert(error.response.data.message);
            } else {
              console.log(error.response);
            }
          });
      } else {
        console.error(`Invalid form, should be impossible with validation rules.`);
      }
    } catch (err) {
      console.error(`ERR: onSubmit error. ${err}`);
    }
  }

  return (
    <>
      <Container fluid className={`no-padding no-margin container-fluid`}>
        <Row>
          <Col lg={6} xl={7} className={styles.loginMarketing}>
            <img src={happyKids} className={styles.marketingImage} />
            <h2 className={styles.marketingText}>Register as a Care Provider.</h2>
          </Col>

          <Col lg={6} xl={5} className={`${styles.providerArea}`}>
            <div style={{ width: "100%", maxWidth: 400, marginBottom: 15, padding: "0 15px" }}>
              <ProgressBar now={25 + step * 25} />
            </div>

            {/* "handleSubmit" will validate your inputs before invoking "onSubmit" */}
            <form
              onSubmit={handleSubmit(onSubmit)}
              className={styles.loginForm}
              style={{
                // Important for not overlapping the button
                position: "relative",
                overflow: "hidden",
              }}
            >
              <div style={{ display: "flex", flexGrow: 1, width: "100%", flexDirection: "column" }}>
                <div style={{ padding: "10px 15px" }}>
                  <div style={{ display: "flex", flexDirection: "row", marginBottom: 3 }}>
                    {/*  <img src={onlineShop} style={{ width: 20, height: 20, marginRight: 10 }} /> */}
                    <h3 className={`h3`}>Care Provider Registration</h3>
                  </div>

                  <InputWithLabel
                    inputId={`tradingName`}
                    label={`Trading name`}
                    placeholder={`Care South-West`}
                    type="text"
                    register={register}
                    error={errors.tradingName}
                    errorMessage={`Required.`}
                    validation={{ required: true, minLength: 3 }}
                  />

                  <InputWithLabel
                    inputId={`companyNumber`}
                    label={`Company number`}
                    placeholder={`12345678`}
                    type="number"
                    register={register}
                    error={errors.companyNumber}
                    errorMessage={`Required. Enter your 8 digit company number.`}
                    validation={{ required: true, minLength: 8, maxLength: 8 }}
                  />

                  <InputWithLabel
                    inputId={`website`}
                    label={`Website`}
                    placeholder=""
                    type="text"
                    register={register}
                  />

                  <InputWithLabel
                    inputId={`locationCount`}
                    label={`Number of locations`}
                    placeholder=""
                    type="number"
                    register={register}
                    error={errors.locationCount}
                    errorMessage={`Required. Please provide an approximate number of locations.`}
                    validation={{ required: true, min: 1, max: 9999 }}
                  />

                  <InputWithLabel
                    inputId={`firstName`}
                    label={`Your first name`}
                    placeholder=""
                    type="text"
                    register={register}
                    error={errors.firstName}
                    errorMessage={`Required.`}
                    validation={{ required: true, minLength: 2 }}
                  />

                  <InputWithLabel
                    inputId={`lastName`}
                    label={`Your last name`}
                    placeholder=""
                    type="text"
                    register={register}
                    error={errors.lastName}
                    errorMessage={`Required.`}
                    validation={{ required: true, minLength: 2 }}
                  />

                  <InputWithLabel
                    inputId={`username`}
                    label={`Your email address`}
                    placeholder=""
                    type="email"
                    register={register}
                    error={errors.username}
                    errorMessage={`Required.`}
                    validation={{ required: true, minLength: 4 }}
                  />

                  <InputWithLabel
                    inputId={`password`}
                    label={`Your password`}
                    placeholder=""
                    type="password"
                    register={register}
                    error={errors.password}
                    errorMessage={`Required. Minimum 6 characters`}
                    validation={{ required: true, minLength: 6 }}
                  />
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  padding: "0px 15px",
                  flexBasis: 50,
                }}
              >
                <input className="btn btn-primary form-control" type="submit" value={`REGISTER`} />
              </div>
            </form>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ProviderSignUp;
